import React, {useState} from 'react';
import {Icon} from '@/components/atoms';
import {COLOR_CODE} from '@/utils/constants/colors';
import PropTypes from 'prop-types';

const InfoItem = ({label, value, isHighlighted, icon, tooltip}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className='col-span-1 pt-4'>
      <div className='flex items-center gap-2'>
        <span className='key text-sm' style={{color: COLOR_CODE._EFEFEF}}>
          {label}
        </span>
        {icon && (
          <button
            className='relative'
            type='button'
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setShowTooltip(!showTooltip);
              }
            }}>
            <Icon alt={icon.alt} icon={icon.name} size={icon.size || 'small'} />
            {showTooltip && tooltip && (
              <div className='shadow-lg absolute left-0 mt-2 w-64 rounded bg-black p-2 text-sm text-white'>
                {tooltip}
              </div>
            )}
          </button>
        )}
      </div>
      <h2
        className='val flex text-base font-bold'
        style={{
          color: isHighlighted
            ? COLOR_CODE._3387DF
            : 'var(--color-text-primary, #EFEFEF)'
        }}>
        {value !== undefined && value !== null && value !== '' ? value : '-'}
      </h2>
    </div>
  );
};

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isHighlighted: PropTypes.bool,
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    size: PropTypes.string
  }),
  tooltip: PropTypes.string
};

export default React.memo(InfoItem);
